export const API = {
    ALL_INDICES: 'getindices'
}